import SearchField from '@components/common/SearchField';
import { useTranslation } from 'react-i18next';

type SearchResultOriginProps = {
  searchTerm: string;
  setSearchTerm: (arg0: string) => void;
};

function SearchResultOrigin(props: SearchResultOriginProps) {
  const { t } = useTranslation('pmo');
  const { searchTerm, setSearchTerm } = props;

  return (
    <div
      style={{ display: 'flex', marginTop: '32px', justifyContent: 'space-between', width: '100%' }}
    >
      <SearchField
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        placeholder={t('search.by.project.or.collaborator') as string}
      />
    </div>
  );
}

export default SearchResultOrigin;
